module.exports = __webpack_public_path__ + "img/301.0f7833a1.png";